import React from "react";
import { IoOpenOutline } from "react-icons/io5";

const ecosystemItems = [
    {
        title: "Dexora DEX",
        description: "Swap tokens and provide liquidity on our decentralized exchange",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
        ),
        link: "/",
        isInternal: true,
    },
    {
        title: "DualYield Staking",
        description: "Stake your tokens and earn dual rewards with competitive APY",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
        ),
        link: "https://dualyield.io",
        isInternal: false,
    },
    {
        title: "Bridge",
        description: "Bridge your assets across chains seamlessly and securely",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
            </svg>
        ),
        link: "https://beta-bridge.complere.xyz/",
        isInternal: false,
    },
    {
        title: "Governance",
        description: "Participate in protocol governance and shape the future of Dexora",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
        link: "#",
        isInternal: false,
        comingSoon: true,
    },
    {
        title: "Analytics",
        description: "Track trading volume, liquidity, and protocol metrics in real-time",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
        ),
        link: "#",
        isInternal: false,
        comingSoon: true,
    },
    {
        title: "Documentation",
        description: "Learn about Dexora protocol, smart contracts, and integration guides",
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
        ),
        link: "#",
        isInternal: false,
        comingSoon: true,
    },
];

const Ecosystem = () => {
    const handleClick = (item) => {
        if (item.comingSoon) return;
        if (item.isInternal) {
            window.location.href = item.link;
        } else {
            window.open(item.link, "_blank");
        }
    };

    return (
        <div className="w-full max-w-[680px] flex flex-col card-3d p-6">
            <div className="mb-6">
                <h2 className="text-[24px] font-bold gradient-text mb-1">Ecosystem</h2>
                <p className="text-[13px] text-dexora-text-muted font-medium">
                    Explore the Dexora ecosystem and connected platforms
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {ecosystemItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => handleClick(item)}
                        className={`pool-card-3d p-4 flex flex-col gap-3 ${
                            item.comingSoon
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"
                        }`}
                    >
                        <div className="flex items-center justify-between">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-dexora-cyan/10 text-dexora-cyan">
                                {item.icon}
                            </div>
                            {item.comingSoon ? (
                                <span className="text-[10px] font-bold uppercase tracking-wider text-dexora-text-muted bg-dexora-dark-tertiary/50 px-2 py-1 rounded-lg">
                                    Soon
                                </span>
                            ) : !item.isInternal ? (
                                <IoOpenOutline className="text-dexora-text-muted size-[14px]" />
                            ) : null}
                        </div>
                        <div>
                            <h3 className="text-[15px] font-bold text-dexora-text-primary mb-1">
                                {item.title}
                            </h3>
                            <p className="text-[12px] text-dexora-text-muted leading-relaxed">
                                {item.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Ecosystem;
